import React, { useState, useEffect } from 'react';
import PageWrapper from '../components/layout/PageWrapper';
import LoadingSpinner from '../components/layout/LoadingSpinner';

interface Staff {
  id: number;
  name: string;
  nameEn: string;
  position: string;
  credentials: string;
  image: string;
}

/**
 * ProSpliceWEB会社概要ページコンポーネント
 * 会社情報とスタッフ紹介を表示
 */
const CompanyPage: React.FC = () => {
  const [staff, setStaff] = useState<Staff[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // スタッフ情報の取得をシミュレート
    const fetchStaff = async () => {
      try {
        // 実際のAPIコールの代わりにダミーデータを使用
        // await new Promise(resolve => setTimeout(resolve, 1000));
        
        const staffData: Staff[] = [
          {
            id: 1,
            name: '中山 農',
            nameEn: 'Atsushi Nakayama',
            position: '代表取締役',
            credentials: '一級建築士',
            image: '/img/staff_atsushi-nakayama.jpeg'
          },
          {
            id: 2,
            name: '中山 夏瀬',
            nameEn: 'Natsuse Nakayama',
            position: '代表取締役',
            credentials: '一級建築士・宅建士',
            image: '/img/staff_natsuse-nakayama.jpg'
          }
        ];
        
        setStaff(staffData);
          } catch (error) {
      if (process.env.NODE_ENV === 'development') {
        console.error('スタッフ情報の取得に失敗しました:', error);
      }
    } finally {
        setLoading(false);
      }
    };

    fetchStaff();
  }, []);

  return (
    <PageWrapper title="会社概要">
      {/* 会社基本情報 */}
      <div className="row mb-3 py-2">
        <div className="col-sm-3 zen-old-mincho-semibold">名称</div>
        <div className="col-sm-9 zen-old-mincho-regular">株式会社SPLICE建築企画</div>
      </div>
      <hr />
      
      <div className="row mb-3 py-2">
        <div className="col-sm-3 zen-old-mincho-semibold">代表</div>
        <div className="col-sm-9 zen-old-mincho-regular">中山 農</div>
      </div>
      <hr />
      
      <div className="row mb-3 py-2">
        <div className="col-sm-3 zen-old-mincho-semibold">設立</div>
        <div className="col-sm-9 zen-old-mincho-regular">2007年4月</div>
      </div>
      
      <div className="row mb-3 py-2">
        <div className="col-sm-3 zen-old-mincho-semibold">開業</div>
        <div className="col-sm-9 zen-old-mincho-regular">2017年9月</div>
      </div>
      <hr />
      
      <div className="row mb-3 py-2">
        <div className="col-sm-3 zen-old-mincho-semibold">所在地</div>
        <div className="col-sm-9 zen-old-mincho-regular">〒111-0053 東京都台東区浅草橋1-1-10 FKビル3F</div>
      </div>
      
      <div className="row mb-3 py-2">
        <div className="col-sm-3 zen-old-mincho-semibold">電話</div>
        <div className="col-sm-9 zen-old-mincho-regular">03-5823-4818</div>
      </div>
      
      <div className="row mb-3 py-2">
        <div className="col-sm-3 zen-old-mincho-semibold">FAX</div>
        <div className="col-sm-9 zen-old-mincho-regular">03-5823-4819</div>
      </div>
      
      <div className="row mb-3 py-2">
        <div className="col-sm-3 zen-old-mincho-semibold">e-mail</div>
        <div className="col-sm-9 zen-old-mincho-regular">inq@splice.bz</div>
      </div>
      <hr />
      
      <div className="row mb-3 py-2">
        <div className="col-sm-3 zen-old-mincho-semibold">建築士事務所</div>
        <div className="col-sm-9 zen-old-mincho-regular">一級 東京都知事登録 第61932号</div>
      </div>
      
      <div className="row mb-3 py-2">
        <div className="col-sm-3 zen-old-mincho-semibold">宅地建物取引業者</div>
        <div className="col-sm-9 zen-old-mincho-regular">東京都知事(2)第102842号</div>
      </div>
      <hr />
      
      <div className="row mb-3 py-2">
        <div className="col-sm-3 zen-old-mincho-semibold">所属</div>
        <div className="col-sm-9 zen-old-mincho-regular">一級建築士 2名・宅地建物取引主任者 1名</div>
      </div>
      
      <div className="row mb-5 py-2">
        <div className="col-sm-3 zen-old-mincho-semibold">主な事業内容</div>
        <div className="col-sm-9 zen-old-mincho-regular">建築設計・不動産取引全般</div>
      </div>
      
      {/* スタッフ紹介 */}
      <div className="mt-5">
        <h4 className="mb-4 zen-old-mincho-bold">スタッフ紹介</h4>
        
        {loading ? (
          <LoadingSpinner message="スタッフ情報を読み込み中..." />
        ) : (
          <div className="row">
            {staff.map((staffMember) => (
              <div key={staffMember.id} className="col-lg-6 mb-5">
                <div className="card border-0 shadow-sm h-100">
                  <div className="card-body">
                    <div className="row align-items-center">
                      {/* スタッフ画像 */}
                      <div className="col-md-4 mb-3 mb-md-0 text-center">
                        <img 
                          src={staffMember.image} 
                          alt={staffMember.name}
                          className="img-fluid rounded"
                          style={{ 
                            width: '150px', 
                            height: '150px',
                            objectFit: 'cover'
                          }}
                          onError={(e) => {
                            (e.target as HTMLImageElement).src = '/img/santouan.jpg';
                          }}
                        />
                      </div>
                      
                      {/* スタッフ情報 */}
                      <div className="col-md-8 text-center text-md-start">
                        {/* デスクトップ表示 */}
                        <div className="d-none d-md-block">
                          <div className="mb-2">
                            <span className="zen-old-mincho-bold me-3">{staffMember.name}</span>
                            <span className="text-muted zen-old-mincho-medium" style={{ fontSize: '0.9rem' }}>
                              {staffMember.nameEn}
                            </span>
                          </div>
                          <div className="mb-2">
                            <span className="zen-old-mincho-semibold me-3">{staffMember.position}</span>
                            <span className="zen-old-mincho-medium" style={{ fontSize: '0.9rem' }}>
                              {staffMember.credentials}
                            </span>
                          </div>
                        </div>
                        
                        {/* モバイル表示 */}
                        <div className="d-md-none">
                          <div className="mb-2">
                            <span className="zen-old-mincho-bold me-3">{staffMember.name}</span>
                            <span className="text-muted zen-old-mincho-medium" style={{ fontSize: '0.9rem' }}>
                              {staffMember.nameEn}
                            </span>
                          </div>
                          <div className="mb-2">
                            <span className="zen-old-mincho-semibold me-3">{staffMember.position}</span>
                            <span className="zen-old-mincho-medium" style={{ fontSize: '0.9rem' }}>
                              {staffMember.credentials}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </PageWrapper>
  );
};

export default CompanyPage; 